/**

 * Design theme — build default via VITE_DESIGN_THEME (light | dark).

 * Runtime override: localStorage key koh-design-theme (see stores/theme.js).

 */

export const BUILD_DEFAULT_THEME =

  (import.meta.env.VITE_DESIGN_THEME || 'light').toLowerCase() === 'dark' ? 'dark' : 'light'



/** @deprecated use BUILD_DEFAULT_THEME */

export const DESIGN_THEME = BUILD_DEFAULT_THEME



/** @deprecated use useThemeStore().isDark */

export const isDarkTheme = BUILD_DEFAULT_THEME === 'dark'



const STORAGE_KEY = 'koh-design-theme'



/** Sync theme before Vue mount to avoid flash of wrong theme. */

export function initThemeEarly() {

  let theme = BUILD_DEFAULT_THEME

  try {

    const stored = localStorage.getItem(STORAGE_KEY)

    if (stored === 'light' || stored === 'dark') theme = stored

  } catch {

    // ignore

  }

  document.documentElement.dataset.theme = theme

}



/** @deprecated use useThemeStore().init() after Pinia is ready */

export function applyTheme() {

  initThemeEarly()

}


